import React from 'react';
import styled from 'styled-components';
import { AdSlot } from 'app/components/ads/AdSlot';
const StyledSponsorAdSlot = styled(AdSlot).withConfig({
  componentId: "sc-yxxuh-0"
})(["&&&{width:90px;height:34px;}"]);
const SponsorAdSlot = _ref => {
  let {
    extendSlotId
  } = _ref;
  return /*#__PURE__*/React.createElement(StyledSponsorAdSlot, {
    noMargin: true,
    adSlotId: "ad-Sponsor_1-".concat(extendSlotId),
    adUnit: 'Sponsor_1',
    limitedDim: false,
    className: "",
    "data-sentry-element": "StyledSponsorAdSlot",
    "data-sentry-component": "SponsorAdSlot",
    "data-sentry-source-file": "SponsorAdSlot.tsx"
  });
};
export default SponsorAdSlot;